<template>
  <div class="yh_aside_box" ref="yhAside">
    <!-- <div class="div" @mouseenter="showall()" @mouseleave="showaleave()"> -->
    <!-- <button class="btn">主菜单</button> -->
    <div class="yh_aside_L0">
      <div
        class="yh_aside_items"
        :class="[{ isactive: aside.activeId === nav.id }]"
        v-for="(nav, ix) in aside.menuList"
        :key="ix"
        :title="nav.label"
        @mouseenter="navShowItems(nav)"
        @click="navRouter(nav)"
      >
        <!-- <img src="../assets/logo.jpg" alt /> -->
        <img :src="nav.icon" alt />
      </div>
    </div>
    <div
      class="yh_aside_L1"
      v-show="aside.list.length > 0"
      @mouseleave="showaleave"
    >
      <!-- <div class="yh_aside_L1" v-show="aside.list.length>0"> -->
      <!-- <cascader :data="aside.menuList" v-show="aside.show"></cascader> -->
      <cascader
        :data="aside.list"
        @getAcived="getAcived"
        v-show="aside.show"
        :height="aside.info.wraperHeight - 2"
      ></cascader>
    </div>
  </div>
</template>

<script>
import Cascader from "./Cascader";

export default {
  components: { Cascader },
  name: "yhAside",
  props: {
    msg: String
  },
  data() {
    return {
      lastPath: "/home", // 上次打开的页面地址
      canotPath: "", // 不跳转的地址
      // 侧边导航栏用的数据
      aside: {
        // 本组件的信息
        info: {
          // 一级/二级/三级 菜单的宽度
          wraperWidth: "",
          wraperHeight: ""
        },
        show: true,
        list: [],
        activeId: "",
        menuList: [
          {
            id: 1,
            label: "首页",
            path: "/home",
            icon: require("../assets/home.png")
          },
          {
            id: 17,
            label: "数据大屏",
            path: "/bigScreen",
            icon: require("../assets/keji_fuwu.png")
          },
          {
            id: 4,
            label: "智能服务",
            path: "",
            icon: require("../assets/fuwu_chuangxin.png"),
            children: [
              {
                id: 312,
                label: "智能推荐",
                path: "/serviceIntelligence/customerRecommend"
              },
              {
                id: 311,
                label: "智能咨询/客服",
                path: "/serviceIntelligence/intelligentService"
              }
              // {
              //   id: 31,
              //   label: "智能服务",
              //   path: "",
              //   children: [
              //     {
              //       id: 311,
              //       label: "智能咨询/客服",
              //       path: "/serviceInnovate/intelligentService"
              //     },
              //     {
              //       id: 312,
              //       label: "智能推荐",
              //       path: "/serviceInnovate/customerRobot"
              //     }
              //   ]
              // },

              // {
              //   id: 36,
              //   label: "政策服务",
              //   path: "/serviceInnovate/policyServices",
              //   children: [
              //     {
              //       id: 361,
              //       label: "政策服务",
              //       path: "/serviceInnovate/policyServices"
              //     }
              //   ]
              // },
              // {
              //   id: 37,
              //   label: "科技学院管理",
              //   path: "",
              //   children: [
              //     {
              //       id: 371,
              //       label: "在线学习管理",
              //       path: "/serviceInnovate/technology"
              //     },
              //     {
              //       id: 372,
              //       label: "案例管理",
              //       path: "/serviceInnovate/technology_case"
              //     },
              //     {
              //       id: 373,
              //       label: "资料管理",
              //       path: "/serviceInnovate/technology_data"
              //     }
              //   ]
              // }
            ]
          },
          {
            id: 2,
            label: "内容管理",
            path: "",
            icon: require("../assets/neirong_guanli.png"),
            children: [
              // {
              //   id: 11,
              //   label: "数据大屏",
              //   path: "/content/bigScreen"
              // },
              {
                id: 12,
                label: "首页轮播图",
                path: "/content/hotImg"
              },
              {
                id: 13,
                label: "首页系统公告",
                path: "/content/systemNotice"
              },
              // {
              //   id: 14,
              //   label: "置顶管理",
              //   path: "/content/topManage"
              // },
              { id: 15, label: "新闻动态", path: "/content/news" },
              { id: 16, label: "关于我们", path: "/content/aboutUs" },
              {
                id: 37,
                label: "信息服务",
                path: "/content/technology/case"
                // children: [
                //   {
                //     id: 371,
                //     label: "在线学习管理",
                //     path: "/content/technology"
                //   },
                //   {
                //     id: 372,
                //     label: "案例管理",
                //     path: "/content/technology_case"
                //   },
                //   {
                //     id: 373,
                //     label: "资料管理",
                //     path: "/content/technology_data"
                //   }
                // ]
              },
              {
                id: 36,
                label: "政策服务",
                path: "/content/policyServices"
                // children: [
                //   {
                //     id: 361,
                //     label: "政策服务",
                //     path: "/serviceInnovate/policyServices"
                //   }
                // ]
              }
            ]
          },
          {
            id: 3,
            label: "用户管理",
            path: "",
            icon: require("../assets/user_manage.png"),
            children: [
              {
                id: 21,
                label: "账号管理",
                path: "/user/accountManage"
              },
              {
                id: 22,
                label: "用户角色审核",
                path: "/user/examineRole"
              },
              { id: 23, label: "角色管理", path: "/user/roleManage" }
            ]
          },
          {
            id: 20,
            label: "科技资源",
            path: "",
            icon: require("../assets/keji_fuwu.png"),
            children: [
              {
                id: 32,
                label: "科技成果",
                path: "/resourcesIT/achievement"
              },
              {
                id: 33,
                label: "科技需求",
                path: "/resourcesIT/demand"
              }
            ]
          },
          {
            id: 8,
            label: "服务创新管理",
            path: "",
            icon: require("../assets/keji_fuwu.png"),
            children: [
              {
                id: 32,
                label: "展会管理",
                path: "/serviceInnovate/exhibition"
                // children: [
                //   {
                //     id: 321,
                //     label: "展会管理",
                //     path: "/serviceInnovate/exhibition"
                //   },
                //   {
                //     id: 322,
                //     label: "展会内容发布",
                //     path: "/serviceInnovate/exhibition_release"
                //   },
                //   {
                //     id: 323,
                //     label: "参展审核",
                //     path: "/serviceInnovate/exhibition_examine"
                //   }
                // ]
              },
              {
                id: 33,
                label: "活动发布",
                path: "/serviceInnovate/active"
                // children: [
                //   {
                //     id: 331,
                //     label: "活动管理",
                //     path: "/serviceInnovate/active"
                //   }
                //   // { id: 332, label: "活动统计", path: "bbbbbbbbbb" }
                // ]
              },
              {
                id: 34,
                label: "在线直播",
                path: "/serviceInnovate/onLineLive"
                // children: [
                //   {
                //     id: 341,
                //     label: "在线直播",
                //     path: "/serviceInnovate/onLineLive"
                //   }
                // ]
              },
              // {
              //   id: 37,
              //   label: "视频点播",
              //   path: "/serviceInnovate/onLineVideo"
              // },
			  {
			    id: 37,
			    label: "内部会议管理",
			    path: "/serviceInnovate/innerFiled"
			  },
              {
                id: 35,
                label: "预约管理",
                path: "/serviceInnovate/appointment"
                // children: [
                //   {
                //     id: 351,
                //     label: "场地预约",
                //     path: "/serviceInnovate/appointment"
                //   },
                //   {
                //     id: 352,
                //     label: "服务预约",
                //     path: "/serviceInnovate/appointment_service"
                //   }
                // ]
              },
              {
                id: 36,
                label: "场地管理",
                path: "/serviceInnovate/field"
              }
            ]
          },
          {
            id: 5,
            label: "科技服务管理",
            path: "",
            icon: require("../assets/keji_fuwu.png"),
            children: [
              {
                id: 51,
                label: "转移转化",
                path: "/serviceIT/transfer",
                children: [
                  {
                    id: 511,
                    label: "技术评估",
                    path: "bbbbbbbbbb"
                  },
                  {
                    id: 512,
                    label: "技术交易",
                    path: "bbbbbbbbbb"
                  },
                  {
                    id: 513,
                    label: "需求审核",
                    path: "bbbbbbbbbb"
                  },
                  {
                    id: 514,
                    label: "成果审核",
                    path: "bbbbbbbbbb"
                  }
                ]
              },
              {
                id: 53,
                label: "知识产权",
                path: "",
                children: [
                  {
                    id: 531,
                    label: "知识产权信息管理",
                    path: "/serviceIT/intellectualProperty"
                  },
                  {
                    id: 532,
                    label: "产权价值评估管理",
                    path: "/serviceIT/intellectualProperty_assess"
                  }
                ]
              },
              {
                id: 54,
                label: "中介服务管理",
                path: "/serviceIT/intermediary",
                children: [
                  {
                    id: 531,
                    label: "中介服务管理",
                    path: "/serviceIT/intermediary"
                  }
                ]
              }
            ]
          },
          {
            id: 6,
            label: "统计分析",
            path: "",
            icon: require("../assets/keji_fuwu.png"),
            children: [
              {
                id: 61,
                label: "活动统计",
                path: "/statistical/statistical_active"
              },
              {
                id: 62,
                label: "其他统计",
                path: "/statistical/statistical_other"
              }
            ]
          },

          {
            id: 7,
            label: "人工客服",
            icon: require("../assets/keji_fuwu.png"),
            path: "/customerService",
            target: "_blank"
          }
          // { id: 7, label: "关于我们", path: "/about" }
        ]
      }
    };
  },
  mounted() {
    this.aside.info.wraperWidth = this.$refs.yhAside.clientWidth;
    this.aside.info.wraperHeight = this.$refs.yhAside.clientHeight;
    document.querySelector(".yh_aside_L1").style.height =
      this.$refs.yhAside.clientHeight - 2 + "px";
    document.querySelector(".yh_aside_L1").style.left =
      this.$refs.yhAside.clientWidth + "px";
  },
  methods: {
    /********************** 导航栏部分的逻辑开始 ↓ **********************/
    showall() {
      this.aside.show = true;
      this.aside.list = this.aside.menuList;
    },
    showaleave() {
      this.aside.show = true;
      this.aside.list = [];
    },
    // 显示子菜单
    navShowItems(li) {
      let _this = this;
      if (li.children && Array.isArray(li.children)) {
        this.aside.activeId = li.id;
        this.aside.list = li.children;
      } else {
        this.aside.list = [li];
        this.aside.activeId = "";
      }
      this.$forceUpdate();
    },
    // 导航栏点击事件
    navRouter(nav) {
      this.routerGo(nav);
      // if (nav.path) {
      //   if (nav.target == '_blank') {
      //     this.$emit('getAcived', nav);
      //     let routeUrl = this.$router.resolve({
      //       path: nav.path,
      //       query: {user_id: 2, user_name: "小明"}
      //     });
      //     window.open(location.pathname + '#' + routeUrl.resolved.fullPath, '_blank'); //线上发布用
      //   } else {
      //     this.$router.push(nav.path);
      //     this.$emit('getAcived', nav);
      //   }
      // }
    },
    // 获取当前激活的选项
    getAcived(dat) {
      // console.log('获取当前激活的选项 aside ::',dat);
      // this.$emit('getAcived', dat);
      this.routerGo(dat);
    },
    // 跳转
    routerGo(nav) {
      if (nav.path) {
        if (
          this.lastPath !== this.canotPath &&
          this.canotPath !== this.$route.fullPath
        ) {
          this.lastPath = this.$route.fullPath;
        }
        if (nav.target == "_blank") {
          this.canotPath = nav.path;
          let routeUrl = this.$router.resolve({
            path: nav.path,
            query: { user_id: 2, user_name: "小明" }
          });
          window.open(
            location.pathname + "#" + routeUrl.resolved.fullPath,
            "_blank"
          ); //线上发布用
          setTimeout(() => {
            this.$router.push(this.lastPath);
          }, 1000);
        } else {
          this.lastPath = nav.path;
          this.$router.push(nav.path);
          this.$emit("getAcived", nav);
        }
      }
    }
    /********************** 导航栏部分的逻辑结束 ↑ **********************/
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.yh_aside_box {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
}

.yh_aside_items {
  position: relative;
  padding: 0.8rem 1.2rem;
  margin: 0;
  cursor: pointer;
  &:hover {
    background-color: #409eff;
    color: #fff;
    border-radius: 0.5rem;
    transition: background-color 0.2s;
  }
}

// 主菜单
.yh_aside_L0 {
  position: relative;
  box-sizing: border-box;
  padding: 1rem 0;
  background-color: #1d385a;
  // border: 1px solid #ddd;
  height: 100%;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}

// 子菜单1
.yh_aside_L1 {
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  min-width: 11rem;
  white-space: normal;
  text-align: left;
  background-color: #fff;
  box-shadow: 5px 5px 10px #ddd;
  z-index: 10000;
  p {
    box-sizing: border-box;
    margin: 0;
    padding: 0.5rem;
  }
}

.isactive {
  color: #fff;
  background-color: #172d48;
}
</style>
